import SectionContainer from "components/molecules/common/SectionContainer"
import { OutboundLink } from "components/atoms/OutboundLink"
import { siteCountry } from "utils/env"
import { useContext } from "react"
import { LocaleContext } from "contexts"
import cc from "classcat"
import countries from "../../../../config/i18n"

const locales = countries[siteCountry] || countries.fi

export default function Questions({ title, texts, className = "" }) {
  const { locale } = useContext(LocaleContext)

  return (
    <SectionContainer
      title={title}
      className={cc(["text-zinc-800", className])}
    >
      <div className="prose whitespace-pre-line text-zinc-800">
        {texts[0]}
        <OutboundLink
          href={`mailto:${locales[locale].contactEmail}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {locales[locale].contactEmail}
        </OutboundLink>
        {texts[1]}
        <OutboundLink
          href={locales[locale].social.instagram}
          target="_blank"
          rel="noopener noreferrer"
        >
          {texts[2]}
        </OutboundLink>
        {texts[3]}
        <OutboundLink
          href={locales[locale].social.facebook}
          target="_blank"
          rel="noopener noreferrer"
        >
          {texts[4]}
        </OutboundLink>
        {texts[5]}
      </div>
    </SectionContainer>
  )
}
